var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localesLoaded)?_c('div',{class:{
    'wc_content_container_inner': _vm.useRootContainer && !_vm.isMobile,
    'wc_content_container_mobile': _vm.useRootContainer && _vm.isMobile
  },attrs:{"id":"wsc_shop_app"}},[_c('router-view',{attrs:{"name":_vm.mediaQueryDevice}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-672d7c5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue
// module id = 181
// module chunks = 39